import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "status-lock-icon",
  role: "img",
  viewBox: "0 0 9 11"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "1.5",
      y: "4.598",
      width: "6",
      height: "5",
      rx: "1.143",
      stroke: "#0F171F",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.329 4.598V3.426a1.829 1.829 0 0 0-3.657 0v1.172",
      stroke: "#0F171F",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }